import { ActivityLogSource, AuthenticationApplication } from "@/enums/enums";
import { AccessToken, CatchAPIService, GetTimezoneOffset, RefreshToken, SetHeaderService } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import service from "../baseHttpService";
/* eslint @typescript-eslint/no-var-requires: "off" */
const qs = require("qs");
class AuthenService {
  DoGetAccessToken(userName: string, password: string, userType = 0, source = ActivityLogSource.None) {
    const { userAgent } = navigator;
    /* eslint-disable @typescript-eslint/camelcase */
    const data = qs.stringify({
      grant_type: "password",
      client_id: "line",
      client_secret: "lineSecret",
      scope: "payroll.api.full openid offline_access account.api.full export.api.full",
      username: userName,
      password: password,
      user_type: userType,
      source: source,
    });
    return service.peakAuthenticationAPI
      .post("/connect/token", data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          ApplicationId: AuthenticationApplication.PeakLineConnect,
          language: i18n.locale,
          timezoneOffset: GetTimezoneOffset(),
          "User-Agent": userAgent,
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => err.response);
  }
  DoGetNewAccessTokenByRefreshToken() {
    const { userAgent } = navigator;
    /* eslint-disable @typescript-eslint/camelcase */
    const data = qs.stringify({
      grant_type: "refresh_token",
      client_id: "line",
      client_secret: "lineSecret",
      refresh_token: RefreshToken(),
      userAgent,
    });

    return service.peakAuthenticationAPI
      .post("/connect/token", data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          ApplicationId: AuthenticationApplication.PeakLineConnect,
          language: i18n.locale,
          timezoneOffset: GetTimezoneOffset(),
          "User-Agent": userAgent,
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => err.response);
  }
  DoGetUserInfo() {
    const headers = {
      Authorization: `Bearer ${AccessToken()}`,
    };
    const params = {};
    return service.peakRealTimeAPIForUser
      .get("/api/User/GetUserInfoByUserId", { params, headers })
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIService(err.response));
  }
  DoGetMerchantListByUserId(isUseMainDatabase = false) {
    const headers = SetHeaderService().headers;
    const params = { isUseMainDatabase: isUseMainDatabase };
    return service.peakRealTimeAPIForUser
      .get("/api/Merchant/GetMerchantListByUserId", { params, headers })
      .then((res) => {
        return res;
      });
  }
  DoGetSelectedMerchant(merchantId: number) {
    const headers = SetHeaderService().headers;
    const params = { merchantId: merchantId };
    return service.peakRealTimeAPIForUser.get("/api/Merchant/GetSelectedMerchant", { params, headers }).then((res) => {
      return res;
    });
  }
}

export default new AuthenService();
